import { gql } from '@apollo/client'

const UPDATE_CUISINE_TYPE_SIMPLE_DETAILS_MUTATION = gql`
  mutation updateCuisineTypeSimpleDetails(
    $id: ID!
    $data: CuisineTypeDetailsInput!
  ) {
    updateCuisineTypeSimpleDetails(id: $id, data: $data) {
      id
      description
      synonyms
      position
      isExcludedFromSearch
      isExcludedFromBrowsing
      updatedAt
      updatedBy {
        id
        name
      }
      isErrorProne
    }
  }
`

export default UPDATE_CUISINE_TYPE_SIMPLE_DETAILS_MUTATION
